export const cardsData = [
  {
    index: '#1368',
    message: 'add documentation for postgres scaler',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'complete',
  },
  {
    index: '#1367',
    message: 'Super cool UI kit for making websites that look like games',
    branch: 'super-cool-ui-kit',
    commit: '952e5567',
    author: 'Vadim Makeev',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'error',
  },
  {
    index: '#1368',
    message: "Merge branch 'master' of github.com:jaywcjlove/awesome",
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'complete',
  },
  {
    index: '#1368',
    message: 'upgrade typescript to 3.8',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'pending',
  },
  {
    index: '#1368',
    message: 'add documentation for postgres scaler',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'complete',
  },
  {
    index: '#1368',
    message: 'replace all `div` to `article`',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'error',
  },
  {
    index: '#1368',
    message: 'fix: upload 别片类型',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'complete',
  },
  {
    index: '#1368',
    message: 'add documentation for postgres scaler',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'complete',
  },
  {
    index: '#1368',
    message: 'add documentation for postgres scaler',
    branch: 'master',
    commit: '9c9f0b9',
    author: 'Philip Kirkorov',
    datetime: '21 янв, 03:06',
    duration: '1 ч 20 мин',
    cardStatus: 'complete',
  },
]

export const moreData = [  {
  index: '#1368',
  message: 'upgrade typescript to 3.8',
  branch: 'master',
  commit: '9c9f0b9',
  author: 'Philip Kirkorov',
  datetime: '21 янв, 03:06',
  duration: '1 ч 20 мин',
  cardStatus: 'pending',
},
{
  index: '#1368',
  message: 'add documentation for postgres scaler',
  branch: 'master',
  commit: '9c9f0b9',
  author: 'Philip Kirkorov',
  datetime: '21 янв, 03:06',
  duration: '1 ч 20 мин',
  cardStatus: 'complete',
},
{
  index: '#1368',
  message: 'replace all `div` to `article`',
  branch: 'master',
  commit: '9c9f0b9',
  author: 'Philip Kirkorov',
  datetime: '21 янв, 03:06',
  duration: '1 ч 20 мин',
  cardStatus: 'error',
},
{
  index: '#1368',
  message: 'fix: upload 别片类型',
  branch: 'master',
  commit: '9c9f0b9',
  author: 'Philip Kirkorov',
  datetime: '21 янв, 03:06',
  duration: '1 ч 20 мин',
  cardStatus: 'complete',
},
{
  index: '#1368',
  message: 'add documentation for postgres scaler',
  branch: 'master',
  commit: '9c9f0b9',
  author: 'Philip Kirkorov',
  datetime: '21 янв, 03:06',
  duration: '1 ч 20 мин',
  cardStatus: 'complete',
},
{
  index: '#1368',
  message: 'add documentation for postgres scaler',
  branch: 'master',
  commit: '9c9f0b9',
  author: 'Philip Kirkorov',
  datetime: '21 янв, 03:06',
  duration: '1 ч 20 мин',
  cardStatus: 'complete',
},]
